module.exports = __webpack_public_path__ + "static/media/vector_right.7518fb94.svg";